import {
  AdministrationMenu,
  CommissionsMenu,
  EndorsementsMenu,
  RiskManagementMenu,
  UtilitiesMenu,
} from './menus';
import { ITabRoutes } from '../util/TabListToRouteList';
import { useUserPermissions } from './useUserPermissions';
import { LrpTeamMenu } from './menus/LrpTeamMenu';
import { MidOfficeMenu } from './menus/MidOfficeMenu';

export type SubMenu = {
  title: string;
  path: string;
  element: React.ReactElement;
  permission: string;
  hidden?: boolean;
  children?: ITabRoutes[];
};

export type Menu = {
  menuTitle: string;
  path: string;
  icon?: React.ReactElement;
  subMenus: SubMenu[];
};

const menus: Menu[] = [
  ...RiskManagementMenu,
  ...EndorsementsMenu,
  ...LrpTeamMenu,
  ...MidOfficeMenu,
  ...CommissionsMenu,
  ...UtilitiesMenu,
  ...AdministrationMenu,
];



export function useCasFilteredNavigation() {
  const { userHasPermission } = useUserPermissions();

  const filteredMenu = menus
    .map((section) => ({
      ...section,
      subMenus: section.subMenus
        .filter((subMenu) => userHasPermission(subMenu.permission))
        .map((subMenu) => {
          const fullPath = `/${section.path}/${subMenu.path}`;
          return {
            ...subMenu,
            path: fullPath, 
          };
      }),
    }))
    .filter((section) => section.subMenus.length > 0); // Filter out sections with no subMenus

  return filteredMenu;
}
